module.exports = __webpack_public_path__ + "static/media/synth_05.41819394.mp3";